import { Link } from "react-router-dom";
import { ArrowRight, Mail, Calculator, CalendarDays, Sparkles } from "lucide-react";

const TOOLS = [
  { to: "/tools/envelope-finder", icon: Mail, t: "Envelope & invitation sizes", d: "Which envelope fits your card and inserts — and will it mail as a letter?" },
  { to: "/tools/suite-postage", icon: Calculator, t: "Suite quantity & postage", d: "Guests → households → how many to order, plus estimated stamps." },
  { to: "/tools/wedding-timeline", icon: CalendarDays, t: "Stationery timeline", d: "Your wedding date → every order-by and mail-by date." },
  { to: "/tools/foil-letterpress-guide", icon: Sparkles, t: "Foil, letterpress & emboss specs", d: "Line weights, foil colours, plates and rush-friendly alternatives." },
];

/* Wedding designer tools, shown above the Wedding Collateral product grid. */
export function WeddingToolsStrip() {
  return (
    <section className="mb-10 bg-kolt-slate-dark text-white p-6 md:p-8" data-testid="wedding-tools-strip">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-5">
        <div>
          <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#E8B587] mb-2">Free tools for stationers & planners</div>
          <h2 className="font-display text-2xl md:text-3xl font-black uppercase tracking-tight">Plan the suite before you print it.</h2>
        </div>
        <Link to="/resources" className="font-mono text-[10px] tracking-[0.22em] uppercase underline text-white/70 hover:text-white" data-testid="wedding-tools-all">All 25 tools →</Link>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {TOOLS.map(({ to, icon: Icon, t, d }) => (
          <Link key={to} to={to} className="group border border-white/15 hover:border-[#E8B587] p-4 transition-colors" data-testid={`wedding-tool-${to.split("/").pop()}`}>
            <Icon className="w-5 h-5 text-[#E8B587] mb-3" />
            <div className="font-display text-sm font-black uppercase tracking-tight leading-tight">{t}</div>
            <p className="text-xs text-white/65 mt-1.5 leading-relaxed">{d}</p>
            <div className="mt-3 font-mono text-[10px] tracking-widest uppercase text-[#E8B587] inline-flex items-center gap-1">Open <ArrowRight className="w-3 h-3 group-hover:translate-x-0.5 transition-transform" /></div>
          </Link>
        ))}
      </div>
    </section>
  );
}
